export default __webpack_public_path__ + "static/singapore-border-corona-0552261604bf95569b6d3e537eaa976c.png";